<template>
  <div class='container'>
    <div v-if='!isConfirm' class='van-toast' style='z-index: 100;width: 100px;'>
      <van-loading size='32px'>信息提交中...</van-loading>
    </div>
    <div v-show='isFirst'>
      <div class='info-title'>{{ hospitalName }}</div>
      <div class='info-tip'>请如实填写信息，以便为您提供更好的服务</div>
      <div>
        <van-field v-model='classTxt' label='选择科室' readonly clickable placeholder='请选择科室' @click='showClass = true' type="textarea" autosize rows="1"
          v-if="!activityType && listClass.length > 1" required />
        <van-field v-model='classTxt' label='科室' class='info-name' required readonly
          v-if="!activityType && listClass.length <= 1" type="textarea" autosize rows="1"/>
        <div class='info-name-field'>
          <van-field v-model='info.name' label='姓名' class='info-name' @keyup="yzName" placeholder='输入或选择姓名' required :error-message="nameErr" />
          <div class='field-sel' @click='showName = true'>选择</div>
        </div>
        <div style="position: relative">
          <van-field name='sex' label='性别'></van-field>
          <van-radio-group v-model='info.gender' direction='horizontal'
            style="position:absolute;width: 5rem; height: 1rem;top: 0;left: 2.5rem;z-index: 1000">
            <van-radio name='0' checked-color='#5CC4AB'>男</van-radio>
            <van-radio name='1' checked-color='#5CC4AB'>女</van-radio>
            <van-radio name='2' checked-color='#5CC4AB'>未知</van-radio>
          </van-radio-group>
        </div>
        <van-field v-model='info.birth' label='出生日期' readonly clickable placeholder='请选择出生日期' @click='showBirth = true'
          required />
        <van-field v-model='info.archivesDate' label='建档日期' readonly clickable placeholder='请选择建档日期'
          v-if="!activityType && !isNoShow" @click='showArchives = true' required />
        <van-field v-model='info.phone' label='手机号码' type="tel" @keyup="yzPhone" placeholder='请输入手机号码' required :error-message="phoneErr" />
        <van-field v-model='info.idCard' label='身份证号' @keyup="yzIdCard" placeholder='请输入身份证号' :required="mustInput.indexOf(';身份证;') >= 0" :error-message="idCareErr" />
        <van-field v-model='info.guardianName' label='监护人姓名' @input="yzGuardianName" placeholder='请输入监护人姓名'
          :required="mustInput.indexOf(';监护人姓名;') >= 0" :error-message="guardianNameErr" />
        <van-field v-model='info.guardianPhone' label='监护人电话' type="tel" @keyup="yzGuardianPhone"  placeholder='请输入监护人电话'
          :required="mustInput.indexOf(';监护人电话;') >= 0" :error-message="guardianPhoneErr"/>
        <div class='info-name-field'>
          <van-field v-model='schoolName' label='所属学校' class='info-name' placeholder='选择学校'
            :required="mustInput.indexOf(';学校;') >= 0" @blur="inputSchool" type="search" />
          <div class='field-sel' @click='showSchool = true'>选择</div>
        </div>
        <div class='other-item-tip' @click='showOtherItem'>
          <div>选填项</div>
          <div><img :src='otherItemImg'></div>
        </div>
        <div v-if='isOtherItem' class='other-item'>
          <van-field v-model='info.nation' label='民族' placeholder='请输入民族' />
          <van-field v-model='info.province' label='省份' readonly clickable placeholder='请选择省份'
            @click='showProvince = true' />

          <van-field v-model='info.city' label='城市' readonly clickable placeholder='请选择城市' @click='showCity = true' />

          <van-field v-model='info.county' label='区县' readonly clickable placeholder='请选择区县' @click='showCounty = true' />
          <van-field v-model='info.address' label='详细地址' placeholder='请输入详细地址' />
        </div>
        <van-popup v-model='showClass' position='bottom'>
          <van-picker :columns='listClass' show-toolbar value-key='clazzName' cancel-button-text='取消'
            confirm-button-text='确定' @cancel='showClass = false' @confirm='onConfirmClass' />
        </van-popup>

        <van-popup v-model='showName' position='bottom'>
          <van-picker :columns='listName' show-toolbar value-key='name' cancel-button-text='取消' confirm-button-text='确定'
            @cancel='showName = false' @confirm='onConfirmName' />
        </van-popup>
        <van-popup v-model='showSchool' position='bottom'>
          <van-search placeholder="请输入学校名称" v-model="positionSearch" @search="onSearch2(positionSearch)" />

          <van-picker :columns='listSchool' show-toolbar value-key='name' cancel-button-text='取消' confirm-button-text='确定'
            @cancel='showSchool = false' @confirm='onConfirmSchool' />
        </van-popup>

        <van-popup v-model='showBirth' position='bottom'>
          <van-datetime-picker :min-date='minDate' v-model='currentDate' type='date' @cancel='showBirth = false'
            @confirm='onConfirmBirth' />
        </van-popup>
        <van-popup v-model='showProvince' position='bottom'>
          <van-picker :columns='listProvince' show-toolbar value-key='itemName' cancel-button-text='取消'
            confirm-button-text='确定' @cancel='showProvince = false' @confirm='onConfirmProvince' />
        </van-popup>
        <van-popup v-model='showCity' position='bottom'>
          <van-picker :columns='listCity' show-toolbar value-key='itemName' cancel-button-text='取消'
            confirm-button-text='确定' @cancel='showCity = false' @confirm='onConfirmCity' />
        </van-popup>
        <van-popup v-model='showCounty' position='bottom'>
          <van-picker :columns='listCounty' show-toolbar value-key='itemName' cancel-button-text='取消'
            confirm-button-text='确定' @cancel='showCounty = false' @confirm='onConfirmCounty' />
        </van-popup>
        <van-popup v-model='showArchives' position='bottom'>
          <van-datetime-picker :min-date='minDate' v-model='currentDate1' type='date' @cancel='showArchives = false'
            @confirm='onConfirmArchives' />
        </van-popup>
      </div>
    </div>
    <div v-show='isSecond'>
      <div class='info-tip'>请如实填写个人信息，以便医生为您提供体检服务</div>
      <div class='module-txt' @click="showTable(0)">
        视力及眼压<img src='../assets/img/menudown.png' :class="showArray[0] ? 'menuup' : 'menudown'" />
      </div>
      <table class='report-table' cellspacing=0 v-if="showArray[0]">
        <tr>
          <td></td>
          <td>视力</td>
          <td>矫正视力</td>
          <td>眼压</td>
        </tr>
        <tr>
          <td>右眼</td>
          <td>
            <div class="flex" @click="showRightShili = true">
              <div class="input-div">
                <div><input placeholder='请选择' v-model='rightShiliTxt' readonly /></div>
                <div><img src="../assets/img/down.png"></div>
              </div>
            </div>
          </td>
          <td>
            <div class="flex" @click='showGRightShili = true'>
              <div class="input-div">
                <div><input placeholder='请选择' v-model='gRightShiliTxt' readonly /></div>
                <div><img src="../assets/img/down.png" class='down-img'></div>
              </div>
            </div>
          </td>
          <td>
            <div class="input-div">
              <input v-model='info.rightPressure' placeholder='请输入' />
            </div>
          </td>
        </tr>
        <tr>
          <td>左眼</td>
          <td>
            <div class="input-div" @click='showLeftShili = true'>
              <div>
                <input placeholder='请选择' v-model='leftShiliTxt' />
              </div>
              <div><img src="../assets/img/down.png" class='down-img'></div>
            </div>
          </td>
          <td>
            <div class="input-div" @click='showGLeftShili = true'>
              <div>
                <input placeholder='请选择' v-model='gLeftShiliTxt' readonly />
              </div>
              <div><img src="../assets/img/down.png" class='down-img'></div>
            </div>
          </td>
          <td>
            <div class="input-div"><input v-model='info.leftPressure' placeholder='请输入' /></div>
          </td>
        </tr>
        <tr>
          <td></td>
          <td colspan="3">
            <div class="input-div" @click='showGlassType = true'>
              <div>
                <input placeholder='戴镜类型' class="input-big" style="width: 5rem;text-align: center;"
                  v-model='glassesTypeTxt' readonly />
              </div>
              <div>
                <img src="../assets/img/down.png" class='down-img'>
              </div>
            </div>
          </td>
        </tr>
      </table>
      <div :class="showArray[0] ? 'module-txt border-no-top' : 'module-txt'" @click="showTable(1)">
        验光数据 <img src='../assets/img/menudown.png' :class="showArray[1] ? 'menuup' : 'menudown'" />
      </div>
      <table class='report-table' cellspacing=0 v-if="showArray[1]">
        <tr>
          <td><span class="require">*</span>是否散瞳</td>
          <td>
            <div class="input-div" @click='showSantong = true' style="padding: 0.1rem 0;">
              <div>
                <input placeholder='请选择' v-model='santongTxt' readonly style="width: 1.15rem;">
              </div>
              <div><img src="../assets/img/down.png" class='down-img'></div>
            </div>
          </td>
          <td><span class="require">*</span>验光方式</td>
          <td>
            <div class="input-div" @click='showYanguang = true' style="padding: 0.1rem 0;">
              <div><input placeholder='请选择' v-model='xianranTxt' readonly style="width: 1.15rem;"></div>
              <div><img src="../assets/img/down.png" class='down-img'></div>
            </div>
          </td>
        </tr>
        <tr>
          <td></td>
          <td>球镜</td>
          <td>柱镜</td>
          <td>轴位</td>
        </tr>
        <tr>
          <td>右眼</td>
          <td>
            <div class="input-div">
              <div><input placeholder='请选择' readonly v-model='info.rightqj' @click='showRightQj = isCanInput'
                  :disabled='!isCanInput' /></div>
              <div><img src="../assets/img/down.png" @click='showRightQj = isCanInput' class='down-img'></div>
            </div>
          </td>
          <td>
            <div class="input-div">
              <div><input placeholder='请选择' v-model='info.rightzj' readonly @click='showRightZj = isCanInput'
                  :disabled='!isCanInput' /></div>
              <div><img src="../assets/img/down.png" @click='showRightZj = isCanInput' class='down-img'></div>
            </div>
          </td>
          <td>
            <div class="input-div">
              <div><input placeholder='请选择' v-model='info.rightzw' :disabled='!isCanInput'></div>
              <div><img src="../assets/img/down.png" @click='showRightZw = isCanInput' class='down-img'></div>
            </div>
          </td>
        </tr>

        <tr>
          <td>左眼</td>
          <td>
            <div class="input-div">
              <div><input placeholder='请选择' readonly v-model='info.leftqj' :disabled='!isCanInput'
                  @click='showLeftQj = isCanInput' /></div>
              <div><img src="../assets/img/down.png" @click='showLeftQj = isCanInput' class='down-img'></div>
            </div>
          </td>
          <td>
            <div class="input-div">
              <div><input placeholder='请选择' readonly v-model='info.leftzj' :disabled='!isCanInput'
                  @click='showLeftZj = isCanInput' /></div>
              <div><img src="../assets/img/down.png" @click='showLeftZj = isCanInput' class='down-img'></div>
            </div>
          </td>
          <td>
            <div class="input-div">
              <div><input placeholder='请选择' v-model='info.leftzw' :disabled='!isCanInput' /></div>
              <div><img src="../assets/img/down.png" @click='showLeftZw = isCanInput' class='down-img'></div>
            </div>
          </td>
        </tr>
        <tr>
          <td>瞳距(mm)</td>
          <td colspan="4">
            <div class="input-div"><input class='input-big' v-model='info.tongju' placeholder='请输入'
                :disabled='!isCanInput' /></div>
          </td>
        </tr>
        <tr>
          <td class="txt-left" style="vertical-align: top;"><br />
            <span>拍照上传验光单据</span>
          </td>
          <td colspan="3" class="img-td">
            <div v-if="!santongTxt || !xianranTxt">请选择是否散瞳和验光方式后上传图片</div>
            <div @click="temp(0)" v-if="!imgShow[0]">
              <div>
                <van-uploader :after-read='afterRead' max-count="1" multiple v-if="!imgShow[0]">
                  <div class='other-photo'>+</div>
                </van-uploader>
              </div>

              <div class='dz-img-box' v-if="info.dlygPicture">
                <div class='dz-img' v-for='(item, index) in info.dlygPicture' :key='index'>
                  <img :src='item' @click="goPriview(item)" /><br />
                  <span @click="goPriview(item)">预览</span>
                  <span @click='goDel(0, "dlygPicture", index)'>删除</span>
                </div>
              </div>
            </div>
            <div @click="temp(1)" v-if="!imgShow[1]">
              <div>
                <van-uploader :after-read='afterRead' multiple="false" v-if="!imgShow[1]">
                  <div class='other-photo'>+</div>
                </van-uploader>
              </div>
              <div class='dz-img-box' v-if="info.xrygPicture">
                <div class='dz-img' v-for='(item, index) in info.xrygPicture' :key='index'>
                  <img :src='item' @click="goPriview(item)" /><br />
                  <span @click="goPriview(item)">预览</span>
                  <span @click='goDel(1, "xrygPicture", index)'>删除</span>
                </div>
              </div>
            </div>
            <div @click="temp(2)" v-if="!imgShow[2]">
              <div>
                <van-uploader :after-read='afterRead' multiple="false" v-if="!imgShow[2]">
                  <div class='other-photo'>+</div>
                </van-uploader>
              </div>

              <div class='dz-img-box' v-if="info.dlygsthPicture">
                <div class='dz-img' v-for='(item, index) in info.dlygsthPicture' :key='index'>
                  <img :src='item' @click="goPriview(item)" /><br />
                  <span @click="goPriview(item)">预览</span>
                  <span @click='goDel(2, "dlygsthPicture", index)'>删除</span>
                </div>
              </div>
            </div>

            <div @click="temp(3)" v-if="!imgShow[3]">
              <div>
                <van-uploader :after-read='afterRead' multiple="false" v-if="!imgShow[3]">
                  <div class='other-photo'>+</div>
                </van-uploader>
              </div>
              <div class='dz-img-box' v-if="info.xrygsthPicture">
                <div class='dz-img' v-for='(item, index) in info.xrygsthPicture' :key='index'>
                  <img :src='item' @click="goPriview(item)" /><br />
                  <span @click="goPriview(item)">预览</span>
                  <span @click='goDel(3, "xrygsthPicture", index)'>删除</span>
                </div>
              </div>
            </div>

            <div @click="temp(4)" v-if="!imgShow[4]">
              <div>
                <van-uploader :after-read='afterRead' multiple="false" v-if="!imgShow[4]">
                  <div class='other-photo'>+</div>
                </van-uploader>
              </div>
              <div class='dz-img-box' v-if="info.dlygfyPicture">
                <div class='dz-img' v-for='(item, index) in info.dlygfyPicture' :key='index'>
                  <img :src='item' @click="goPriview(item)" /><br />
                  <span @click="goPriview(item)">预览</span>
                  <span @click='goDel(4, "dlygfyPicture", index)'>删除</span>
                </div>
              </div>
            </div>

            <div @click="temp(5)" v-if="!imgShow[5]">
              <div>
                <van-uploader :after-read='afterRead' multiple="false" v-if="!imgShow[5]">
                  <div class='other-photo'>+</div>
                </van-uploader>
              </div>
              <div class='dz-img-box' v-if="info.xrygfyPicture">
                <div class='dz-img' v-for='(item, index) in info.xrygfyPicture' :key='index'>
                  <img :src='item' @click="goPriview(item)" /><br />
                  <span @click="goPriview(item)">预览</span>
                  <span @click='goDel(5, "xrygfyPicture", index)'>删除</span>
                </div>
              </div>
            </div>
          </td>
        </tr>
        <tr>
          <td colspan="4" class="txt-tip">注：选择是否散瞳和验光方式后才能填写以上数据</td>
        </tr>
      </table>
      <div :class="showArray[1] ? 'module-txt border-no-top' : 'module-txt'" @click="showTable(2)">
        配镜单上传 <img src='../assets/img/menudown.png' :class="showArray[2] ? 'menuup' : 'menudown'" />
      </div>
      <table class='report-table' cellspacing=0 v-if="showArray[2]">
        <tr>
          <td class="img-td" @click="temp(10)">
            <div>
              <van-uploader :after-read='afterRead'>
                <div class='other-photo'>+</div>
              </van-uploader>
            </div>
            <div class='dz-img-box' v-if="info.glassesRecipe">
              <div class='dz-img' v-for='(item, index) in info.glassesRecipe' :key='index'>
                <img :src='item' @click="goPriview(item)" /><br />
                <span @click="goPriview(item)">预览</span>
                <span @click='goDel(10, "glassesRecipe", index)'>删除</span>
              </div>
            </div>
          </td>
        </tr>
      </table>
      <div :class="showArray[2] ? 'module-txt border-no-top' : 'module-txt'" @click="showTable(3)">
        曲率眼轴(生物测量仪) <img src='../assets/img/menudown.png' :class="showArray[3] ? 'menuup' : 'menudown'" />
      </div>
      <table class='report-table' cellspacing=0 v-if="showArray[3]">
        <tr>
          <td></td>
          <td>眼轴</td>
          <td>曲率K1</td>
          <td>曲率K2</td>
        </tr>
        <tr>
          <td>右眼</td>
          <td>
            <div class="input-div"><input v-model='info.rightAxialLength' placeholder='请输入' /></div>
          </td>
          <td>
            <div class="input-div"><input v-model='info.rightEyeCurvatureR1' placeholder='请输入' /></div>
          </td>
          <td>
            <div class="input-div"><input v-model='info.rightEyeCurvatureR2' placeholder='请输入' /></div>
          </td>
        </tr>

        <tr>
          <td>左眼</td>
          <td>
            <div class="input-div"><input v-model='info.leftAxialLength' placeholder='请输入' /></div>
          </td>
          <td>
            <div class="input-div"><input v-model='info.leftEyeCurvatureR1' placeholder='请输入' /></div>
          </td>
          <td>
            <div class="input-div"><input v-model='info.leftEyeCurvatureR2' placeholder='请输入' /></div>
          </td>
        </tr>
        <tr>
          <td class="img-td" @click="temp(6)" colspan="4">
            <div class="flex" style="vertical-align: top;">
              <div style="width: 1.2rem;margin: 0 0.3rem;text-align: left;">拍照上传生物测量报告图片</div>
              <div style="text-align: center;width: 5.5rem;">
                <van-uploader :after-read='afterRead'>
                  <div class='other-photo'>+</div>
                </van-uploader>
              </div>
              <div class='dz-img-box' v-if="info.righttopographypicture">
                <div class='dz-img' v-for='(item, index) in info.righttopographypicture' :key='index'>
                  <img :src='item' @click="goPriview(item)" /><br />
                  <span @click="goPriview(item)">预览</span>
                  <span @click='goDel(6, "righttopographypicture", index)'>删除</span>
                </div>
              </div>
            </div>
          </td>
        </tr>
      </table>
      <div :class="showArray[3] ? 'module-txt border-no-top' : 'module-txt'" @click="showTable(4)">
        角膜地形图 <img src='../assets/img/menudown.png' :class="showArray[4] ? 'menuup' : 'menudown'" />
      </div>
      <table class='report-table' cellspacing=0 v-if="showArray[4]">
        <tr>
          <td style="line-height:1.5rem;vertical-align: top;"><span>右眼</span></td>
          <td class='td-big img-td' style="vertical-align: top;" @click="temp(8)">
            <div>
              <van-uploader :after-read='afterRead'>
                <div class='other-photo'>+</div>
              </van-uploader>
            </div>
            <div class='dz-img-box' v-if="info.rightbiometricspicture">
              <div class='dz-img' v-for='(item, index) in info.rightbiometricspicture' :key='index'>
                <img :src='item' @click="goPriview(item)" /><br />
                <span @click="goPriview(item)">预览</span>
                <span @click='goDel(8, "rightbiometricspicture", index)'>删除</span>
              </div>
            </div>
          </td>
          <td style="line-height:1.5rem;vertical-align: top;">左眼</td>
          <td class='td-big img-td' @click="temp(9)" style="vertical-align: top;">
            <div>
              <van-uploader :after-read='afterRead'>
                <div class='other-photo'>+</div>
              </van-uploader>
            </div>
            <div class='dz-img-box' v-if="info.leftbiometricspicture">
              <div class='dz-img' v-for='(item, index) in info.leftbiometricspicture' :key='index'>
                <img :src='item' @click="goPriview(item)" /><br />
                <span @click="goPriview(item)">预览</span>
                <span @click='goDel(9, "leftbiometricspicture", index)'>删除</span>
              </div>
            </div>
          </td>
        </tr>

      </table>

      <div :class="showArray[4] ? 'module-txt border-no-top' : 'module-txt'" @click="showTable(5)">
        视功能 <img src='../assets/img/menudown.png' :class="showArray[5] ? 'menuup' : 'menudown'" />
      </div>
      <table class='report-table' cellspacing=0 v-if="showArray[5]">
        <tr>
          <td class='td-big img-td' @click="temp(11)">
            <div>
              <van-uploader :after-read='afterRead'>
                <div class='other-photo'>+</div>
              </van-uploader>
            </div>
            <div class='dz-img-box' v-if="info.visualFunctionPicture">
              <div class='dz-img' v-for='(item, index) in info.visualFunctionPicture' :key='index'>
                <img :src='item' @click="goPriview(item)" /><br />
                <span @click="goPriview(item)">预览</span>
                <span @click='goDel(11, "visualFunctionPicture", index)'>删除</span>
              </div>
            </div>
          </td>
        </tr>
      </table>

      <div :class="showArray[5] ? 'module-txt border-no-top' : 'module-txt'" @click="showTable(6)">
        其他检查图片 <img src='../assets/img/menudown.png' :class="showArray[6] ? 'menuup' : 'menudown'" />
      </div>
      <div @click="temp(20)" class='dz-img-box' v-if="showArray[6]">
        <van-uploader :after-read='afterRead' multiple>
          <div class='other-photo'>+</div>
        </van-uploader>
      </div>
      <div class='dz-img-box' v-if="showArray[6]">
        <div v-for='(item, index) in imgList' :key='index' class='dz-img'>
          <img :src='item' @click="goPriview(item)" /><br />
          <span @click="goPriview(item)">预览</span>
          <span @click='goDel(index)'>删除</span>
        </div>
      </div>
      <van-popup v-model='showRightShili' position='bottom'>
        <van-picker :columns='listShili' show-toolbar value-key='txt' cancel-button-text='取消' confirm-button-text='确定'
          @cancel='showRightShili = false' @confirm='onConfirmRightShili' />
      </van-popup>
      <van-popup v-model='showLeftShili' position='bottom'>
        <van-picker :columns='listShili' show-toolbar value-key='txt' cancel-button-text='取消' confirm-button-text='确定'
          @cancel='showLeftShili = false' @confirm='onConfirmLeftShili' />
      </van-popup>
      <van-popup v-model='showGlassType' position='bottom'>
        <van-picker :columns='listGlassType' show-toolbar value-key='txt' cancel-button-text='取消' confirm-button-text='确定'
          @cancel='showGlassType = false' @confirm='onConfirmGlassType' />
      </van-popup>
      <van-popup v-model='showGRightShili' position='bottom'>
        <van-picker :columns='listShili' show-toolbar value-key='txt' cancel-button-text='取消' confirm-button-text='确定'
          @cancel='showGRightShili = false' @confirm='onConfirmGRightShili' />
      </van-popup>
      <van-popup v-model='showGLeftShili' position='bottom'>
        <van-picker :columns='listShili' show-toolbar value-key='txt' cancel-button-text='取消' confirm-button-text='确定'
          @cancel='showGLeftShili = false' @confirm='onConfirmGLeftShili' />
      </van-popup>
      <van-popup v-model='showSantong' position='bottom'>
        <van-picker :columns='listSantong' show-toolbar value-key='txt' cancel-button-text='取消' confirm-button-text='确定'
          @cancel='showSantong = false' @confirm='onConfirmSantong' />
      </van-popup>
      <van-popup v-model='showYanguang' position='bottom'>
        <van-picker :columns='listYanguang' show-toolbar value-key='txt' cancel-button-text='取消' confirm-button-text='确定'
          @cancel='showYanguang = false' @confirm='onConfirmYanguang' />
      </van-popup>
      <van-popup v-model='showRightQj' position='bottom'>
        <van-picker :columns='listJl' show-toolbar :default-index='40' cancel-button-text='取消' confirm-button-text='确定'
          @cancel='showRightQj = false' @confirm='onConfirmRightQj' />
      </van-popup>
      <van-popup v-model='showRightZj' position='bottom'>
        <van-picker :columns='listJl' show-toolbar :default-index='40' cancel-button-text='取消' confirm-button-text='确定'
          @cancel='showRightZj = false' @confirm='onConfirmRightZj' />
      </van-popup>
      <van-popup v-model='showRightZw' position='bottom'>
        <van-picker :columns='listZw' show-toolbar :default-index='59' cancel-button-text='取消' confirm-button-text='确定'
          @cancel='showRightZw = false' @confirm='onConfirmRightZw' />
      </van-popup>
      <van-popup v-model='showRightJz' position='bottom'>
        <van-picker :columns='listShili' show-toolbar :default-index='3' value-key='txt' cancel-button-text='取消'
          confirm-button-text='确定' @cancel='showRightJz = false' @confirm='onConfirmRightJz' />
      </van-popup>
      <van-popup v-model='showLeftQj' position='bottom'>
        <van-picker :columns='listJl' show-toolbar :default-index='40' value-key='txt' cancel-button-text='取消'
          confirm-button-text='确定' @cancel='showLeftQj = false' @confirm='onConfirmLeftQj' />
      </van-popup>
      <van-popup v-model='showLeftZj' position='bottom'>
        <van-picker :columns='listJl' show-toolbar :default-index='40' cancel-button-text='取消' confirm-button-text='确定'
          @cancel='showLeftZj = false' @confirm='onConfirmLeftZj' />
      </van-popup>
      <van-popup v-model='showLeftZw' position='bottom'>
        <van-picker :columns='listZw' show-toolbar :default-index='59' cancel-button-text='取消' confirm-button-text='确定'
          @cancel='showLeftZw = false' @confirm='onConfirmLeftZw' />
      </van-popup>
      <van-popup v-model='showLeftJz' position='bottom'>
        <van-picker :columns='listShili' show-toolbar :default-index='3' value-key='txt' cancel-button-text='取消'
          confirm-button-text='确定' @cancel='showLeftJz = false' @confirm='onConfirmLeftJz' />
      </van-popup>
      <van-popup v-model="isShowConfirm">
        <div class="con_box">
          <div class="pop-btn">
            <h3>提示</h3>
            <p>确定删除该图片吗？</p>
            <span @click="isShowConfirm = false">取消</span>
            <span @click="delImg()">确定</span>
          </div>
        </div>
      </van-popup>
    </div>
    <van-button class='submit-btn' @click='submitInfo(type)' v-show='(!isNext || isSecond) && isConfirm'>提交</van-button>
    <van-button class='submit-btn' @click='goNext' v-show='(isNext && isFirst) && isConfirm'>下一步</van-button>
  </div>
</template>
<script lang="script">
import { ImagePreview } from 'vant';
import axios from 'axios'
import { compressImage } from '../assets/js/compass.js';
export default {
  name: 'checkin',
  data() {
    return {
      zIndex: 'z-index:' + Math.random(1000),
      imgShow: [true, true, true, true, true, true],
      hospitalId: this.$route.query.hospitalId,
      studentActivityId: '',
      studentId: '',
      showArchives: false,
      healthArchivesId: '',
      imgList: [],
      isGlassSl: false,
      isXr: false,
      isCanInput: false,
      isShowConfirm: false,
      delImgIndx: '',
      imgIndex: '',
      delImgName: '',
      schoolName: '',
      isFirst: true,
      isSecond: false,
      isNext: false,

      phoneErr: '',
      guardianPhoneErr: '',
      guardianNameErr: '',
      nameErr: '',
      idCareErr: '',

      isConfirm: true,
      isSupplement: false,
      isOtherItem: false,
      showNext: false,
      showClass: false,
      showName: false,
      showSchool: false,
      showBirth: false,
      showProvince: false,
      showCity: false,
      showCounty: false,
      showRightShili: false,
      showLeftShili: false,
      showGRightShili: false,
      showGLeftShili: false,
      showGlassType: false,
      showSantong: false,
      showYanguang: false,
      showRightQj: false,
      showRightZj: false,
      showRightZw: false,
      showRightJz: false,
      showLeftQj: false,
      showLeftZj: false,
      showLeftZw: false,
      showLeftJz: false,
      hospitalName: '',
      showArray: [1, 1, 1, 1, 1, 1, 1, 1],
      type: this.$route.query.type,
      id: this.hospitalId,
      rightShiliTxt: '',
      leftShiliTxt: '',
      gRightShiliTxt: '',
      gLeftShiliTxt: '',
      leftJzTxt: '',
      rightJzTxt: '',
      classTxt: '',
      nameTxt: '',
      santongTxt: '',
      xianranTxt: '',
      glassesTypeTxt: '',
      info: {
        age: 0,
        customerSourceTwoId: '',
        school: '',
        archivesDate: '',
        idCard: '',
        classId: '',
        name: '',
        gender: '0',
        birth: '',
        phone: '',
        minzu: '',
        province: '',
        city: '',
        county: '',
        address: '',
        guardianName: '',
        guardianPhone: '',
        rightNakedFar: '',
        leftNakedFar: '',
        glassesType: '',
        rightGlassesFar: '',
        leftGlassesFar: '',
        santong: 0,
        xianran: 0,
        rightqj: '',
        rightzj: '',
        rightzw: '',
        rightjz: '',
        leftqj: '',
        leftzj: '',
        leftzw: '',
        leftjz: '',
        tongju: '',
        rightPressure: '',
        leftPressure: '',
        rightAxialLength: '',
        leftAxialLength: '',
        otherRightPicture: '',
        rightEyeCurvatureR1: '',
        leftEyeCurvatureR1: '',
        rightEyeCurvatureR2: '',
        leftEyeCurvatureR2: '',
        dlygPicture: [],// 非散瞳（电脑）验光图片
        xrygPicture: [],// 非散瞳（显然）验光图片
        dlygsthPicture: [],//  散瞳（电脑）验光图片
        xrygsthPicture: [],//   散瞳（显然）验光图片
        dlygfyPicture: [],//   复验（电脑）验光图片
        xrygfyPicture: [],//    复验（显然）验光图片
        righttopographypicture: [],// 右眼生物测量仪图片
        lefttopographypicture: [],//左眼生物测量仪图片
        rightbiometricspicture: [],//右眼角膜地形图图片
        leftbiometricspicture: [],//左眼角膜地形图图片
        glassesRecipe: [],//配镜处方图片
        visualFunctionPicture: [],//视功能图片
      },
      minDate: new Date(1950, 0, 1),
      otherItemImg: require('../assets/img/down.png'),
      currentDate: new Date(new Date().getTime()),
      currentDate1: new Date(new Date().getTime()),
      listName: [],
      listSchool: [],
      listClass: [],
      listProvince: [],
      listCity: [],
      listCounty: [],
      listGlassType: [{ txt: '框架眼镜', val: 1 }, { txt: '隐形眼镜', val: 2 },
      { txt: '夜戴角膜塑形镜', val: 3 }],
      listSantong: [{ txt: '未散瞳', val: 1 }, { txt: '瞳孔已散大', val: 2 }, { txt: '散瞳后瞳孔已恢复', val: 3 }],
      listYanguang: [{ txt: '电脑验光（自动出条）', val: 1 }, { txt: '显然验光（手动插片）', val: 2 }],
      listShili: [
        { txt: '5.3(2.0)', val: '5.3' },
        { txt: '5.2(1.5)', val: '5.2' },
        { txt: '5.1(1.2)', val: '5.1' },
        { txt: '5.0(1.0)', val: '5.0' },
        { txt: '4.95(0.9)', val: '4.95' },
        { txt: '4.9(0.8)', val: '4.9' },
        { txt: '4.85(0.7)', val: '4.85' },
        { txt: '4.8(0.6)', val: '4.8' },
        { txt: '4.7(0.5)', val: '4.7' },
        { txt: '4.6(0.4)', val: '4.6' },
        { txt: '4.5(0.3)', val: '4.5' },
        { txt: '4.4(0.25)', val: '4.4' },
        { txt: '4.3(0.2)', val: '4.3' },
        { txt: '4.2(0.15)', val: '4.2' },
        { txt: '4.1(0.12)', val: '4.1' },
        { txt: '4.0(0.1)', val: '4.0' },
        { txt: '3.9(0.08)', val: '3.9' },
        { txt: '3.8(0.06)', val: '3.8' },
        { txt: '3.6(0.04)', val: '3.6' },
        { txt: '3.5(0.03)', val: '3.5' },
        { txt: '3.4(0.025)', val: '3.4' },
        { txt: '3.3(0.02)', val: '3.3' },
        { txt: '3.2(0.016)', val: '3.2' },
        { txt: '3.1(0.012)', val: '3.1' },
        { txt: '3.0(0.01)', val: '3.0' }
      ],
      listJl: [],
      listZw: [],
      activityType: null,
      schoolId: '',
      mjSchoolId: null,
      isNoShow: false,
      topicGroupId: undefined,
      topicId: undefined,
      mustInput: '',
      positionSearch:'',
      sourceSchoolList: [],
      token: '',
      longitude: null,
      latitude: null,
    }
  },
  mounted() {
    document.title = '个人基础信息表';
    this.studentActivityId = this.$route.query.studentActivityId;
    this.activityType = this.$route.query.activityType;
    this.hospitalId = this.$route.query.hospitalId;
    if (this.$route.query.schoolId) {
      this.mjSchoolId = this.$route.query.schoolId; //门诊id 门诊二维码带的
    }
    //ysgInfo  页面  有&type即是自主建档
    this.getCurrentLocation();
    this.getClazzIdsByHospitalId();
    this.topicId = this.$route.query.topicId;
    this.topicGroupId = this.$route.query.topicGroupId;
    let jlArray = new Array();
    let zwArray = new Array();
    let jlStart = 10;
    jlArray.push(jlStart)
    while (jlStart > -20) {
      jlStart = jlStart - 0.25;
      jlArray.push(jlStart)
    }
    for (let loop = 1; loop <= 180; loop++) {
      zwArray.push(loop);
    }
    this.listJl = jlArray;
    this.listZw = zwArray;
    if (this.type == '1') this.isNext = true;
    this.getHospitalInfo();
    
    this.getListByOpenId();
    this.getAddress(0, 0);
    this.getSchools();
    if(this.topicId) this.getTopicRequired(this.topicId,'');
    if(this.mjSchoolId) this.getTopicRequired('',this.mjSchoolId);

    this.info.archivesDate = this.$dateFormat('YYYY-mm-dd', new Date());
    if(this.activityType && this.activityType!=null && this.activityType!='null' && this.activityType!='undefined') {
      this.getActivityInfo();
      this.info.archivesDate = this.$dateFormat('YYYY-mm-dd', new Date());
      this.info.archivesDate = this.info.archivesDate.replace(/-/g, '/');
    }
    if(!this.activityType && location.href.indexOf('&activityType')>=0){
      this.isNoShow = true;
    }
    this.getToken();
  },
  methods: {
    async getToken() {
      axios({
        url: '/oauth/2.0/token?grant_type=client_credentials&client_id=XXiOGimN9gBvN6IQ6rZbmfTH&client_secret=BqF47yPTlCt3XyrURVtmpG1au4lhDU5Y',
        method: 'post',
      }).then(res => {
        this.token = res.data.access_token;
      });
    },
    // 获取当前经纬度
    async getCurrentLocation() {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(position => {
            // this.position = {
            //   lng: position.coords.longitude,
            //   lat: position.coords.latitude
            // }
            this.longitude = position.coords.longitude
            this.latitude = position.coords.latitude

            this.getClazzIdsByHospitalId();
          },
          error => {
            //alert("err="+error);
            // this.getClazzIdsByHospitalId();
          }
        );
      }
    },
    async ocrImg(img, imgIndex) {
      axios({
        url: `/baiduApi/rest/2.0/ocr/v1/accurate?access_token=${this.token}&url=${img}`,
        method: 'post',
      }).then(res => {
        let wordList = res.data.words_result;
        if (wordList && wordList.length > 0) {
          let wordRow = [];
          let hasPosition = [];
          let rowIndex = 0;
          wordList.forEach((item) => {
            if (hasPosition.length > 0) {
              let temp = hasPosition.filter(itemPosition => Math.abs(itemPosition.top - item.location.top) < 10);

              if (temp && temp.length > 0) {
                let tempObj = temp[0];
                wordRow[tempObj.index].rowText += item.words.split(/[\t\r\f\n\s]*/g).join('');
              } else {
                let tempIndex = hasPosition.length;
                hasPosition.push({ top: item.location.top, index: tempIndex });
                wordRow.push({
                  rowText: item.words.split(/[\t\r\f\n\s]*/g).join(''),
                  rowIndex: tempIndex,
                })
              }
            } else {
              hasPosition.push({ top: item.location.top, index: rowIndex });
              wordRow.push({
                rowText: item.words.split(/[\t\r\f\n\s]*/g).join(''),
                rowIndex,
              })
            }
          });

          let rData = [], lData = [], seRdata = '', seLdata = '', pdData = '';
          let numberRsca = '-1', numberSeR = '-1', numberSeL = '-1';
          let numberLdataR = '-1', numberLdataL = '-1', numberPs = '-1';
          let numberPd = '-1', numberLsca = '-1';
          let tempRSCA = wordRow.filter(item => item.rowText == '<R>SCA' || item.rowText == '<R>CA');
          if (tempRSCA && tempRSCA.length > 0) numberRsca = tempRSCA[0].rowIndex;
          let tempSE = wordRow.filter(item => item.rowText.indexOf('S.E.') >= 0);
          if (tempSE && tempSE.length > 0) {
            numberSeR = tempSE[0].rowIndex;
            numberSeL = tempSE[1].rowIndex;
          }
          let tempLDATA = wordRow.filter(item => item.rowText == 'L.DATA');
          if (tempLDATA && tempLDATA.length > 0) {
            numberLdataR = tempLDATA[0].rowIndex;
            numberLdataL = tempLDATA[1].rowIndex;
          }
          let tempPS = wordRow.filter(item => item.rowText.indexOf('PS') >= 0);
          if (tempPS && tempPS.length > 0) numberPs = tempPS[0].rowIndex;
          let tempPD = wordRow.filter(item => item.rowText.indexOf('PD') >= 0);
          if (tempPD && tempPD.length > 0) numberPd = tempPD[0].rowIndex;
          let tempLSCA = wordRow.filter(item => item.rowText == '<L>SCA' || item.rowText == '<L>CA');
          if (tempLSCA && tempLSCA.length > 0) numberLsca = tempLSCA[0].rowIndex;
          wordRow.forEach(item => {
            if (numberRsca > 0 && item.rowIndex > numberRsca && item.rowIndex < numberSeR) {
              rData.push(this.formatSCAData(item.rowText))
            }
            if (numberRsca > 0 && item.rowIndex > numberRsca && item.rowIndex < numberLdataR) {
              rData.push(this.formatSCAData(item.rowText))
            }
            if (numberLsca > 0 && item.rowIndex > numberLsca && item.rowIndex < numberSeL) {
              lData.push(this.formatSCAData(item.rowText))
            }
            if (numberLsca > 0 && item.rowIndex > numberLsca && item.rowIndex < numberLdataL) {
              lData.push(this.formatSCAData(item.rowText))
            }
            if (numberSeR > 0 && item.rowIndex == numberSeR) {
              seRdata = item.rowText.replace('S.E.', '');
            }
            if (numberSeL > 0 && item.rowIndex == numberSeL) {
              seLdata = item.rowText.replace('S.E.', '');
            }
            if (numberPd > 0 && item.rowIndex == numberPd) {
              pdData = item.rowText.replace('PD', '');
              pdData = pdData.replace(':', '');
            }
          });
          let endRData = rData[rData.length - 1];
          let endLData = lData[lData.length - 1];
          let arr = ['rightqj','rightzj','rightzw','leftqj','leftzj','leftzw','tongju'];
          this.setSelectValue(arr, endRData, endLData, pdData);
          this.$toast('图片识别完毕，请核对数据！', 3000)
        }
      });
    },
    setSelectValue(arr, endRData, endLData, pdData) {
      this.info[arr[0]] = endRData.s;
      this.info[arr[1]] = endRData.c;
      this.info[arr[2]] = endRData.a;
      this.info[arr[3]] = endLData.s;
      this.info[arr[4]] = endLData.c;
      this.info[arr[5]] = endLData.a;
      this.info[arr[6]] = pdData;
    },
    //正则校验手机号
    yzPhone(){
      console.log('手机号'+this.info.phone);
      let result = true;
      if(this.info.phone) {
        if(!new RegExp(/^1[3|4|5|6|7|8|9][0-9]\d{8}$/).test(this.info.phone)){
         this.phoneErr = '手机号码格式不正确';
         result = false;
        }else{
          this.phoneErr = '';
        }
      }
    },
    //正则校验监护人手机号
    yzGuardianPhone(){
      console.log(this.info.guardianPhone);
      let result = true;
      if(this.info.guardianPhone) {
        if(!new RegExp(/^1[3|4|5|6|7|8|9][0-9]\d{8}$/).test(this.info.guardianPhone)){
         this.guardianPhoneErr = '监护人手机号码格式不正确';
         result = false;
        }else{
          this.guardianPhoneErr = '';
        }
      }else {
        if (this.mustInput.indexOf(';监护人电话;') > 0) {
          this.guardianPhoneErr = '监护人手机号码不能为空';
          result = false;
        }
      }
    },
    //正则校验姓名
    yzName(){
      console.log(this.info.name);
      if(this.info.name) {
        if(!new RegExp(/^[\u0391-\uFFE5A-Za-z]+$/).test(this.info.name)){
         this.nameErr = '姓名格式不正确';
        }else{
          this.nameErr = '';
        }
      }
    },
    //正则校验监护人姓名
    yzGuardianName(){
      console.log(this.info.guardianName);
      let result = true;
      if(this.info.guardianName) {
        if(!new RegExp(/^[\u4E00-\u9FA5A-Za-z]+$/).test(this.info.guardianName)){
         this.guardianNameErr = '监护人姓名格式不正确';
         result = false;
        }else{
          this.guardianNameErr = '';
        }
      }else {
        if (this.mustInput.indexOf(';监护人姓名;') > 0) {
          this.guardianNameErr = '监护人姓名不能为空';
          result = false;
        }
      }
    },
    yzIdCard(){
      console.log(this.info.idCard);
      if (this.info.idCard) {
        let yz1 = /(^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$)|(^[1-9]\d{5}\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{2}$)/.test(this.info.idCard);
        let yz2 = /(^[a-zA-Z][0-9]{9})|(^[A-Z][0-9]{8})|(^[A-Z][0-9]{6}[(（][0-9a-zA-z][)）])$/.test(this.info.idCard);
        if (!yz1 && !yz2) {
          this.idCareErr = '身份证不符合规则';
        }else{
          this.idCareErr = '';
        }
      }
    },
    formatSCAData(value) {
      value = value.replace('<','');
      value = value.replace('>','');
      value = value.replace(/×/ig,'');
      let s = value.substring(0, value.indexOf('.') + 3);
      let temp = value.substring(s.length);
      let c = temp.substring(0, temp.indexOf('.') + 3);
      let a = value.substring(s.length + c.length);
      return { s, c, a };
    },
    inputSchool() {
      this.showSchool = true;
      this.positionSearch = this.schoolName;
      this.onSearch2(this.schoolName);
    },
    async onSearch2(val, autoCommit, type, isNext){
      let result = await this.$http.get(this.$url.getCustomerSourceTwos, {
        hospitalId: this.hospitalId,
        name: val
      });
      
      this.listSchool = result.data.data;
      if( !this.listSchool || this.listSchool.length === 0) {
        this.schoolName = val;
      }
      if(autoCommit) {
        this.info.customerSourceTwoId = this.listSchool[0].id;
        this.submitInfo(type, isNext)
      }
    },
    async getSchools() {
      let result = await this.$http.get(this.$url.getCustomerSourceTwos, {
        hospitalId: this.hospitalId,
      });
      
      this.listSchool = result.data.data;
      this.sourceSchoolList = result.data.data;
    },
    async getTopicRequired(topicId, schoolId) {
      let query = { openId:this.$route.query.openId };
      if(topicId) query.topicId = topicId;
      if(schoolId) query.schoolId = schoolId;
      let result = await this.$http.get(this.$url.getTopicRequiredByTopicId, query);
      let list = result.data.data;
      let mustInput = '';
      if(list && list.length > 0) {
        let hasList = list.filter(item => item.mustType === 1);
        if(hasList && hasList.length > 0) {
          hasList.forEach(item => {
            mustInput += ';'+ item.content +';';
          })
          this.mustInput = mustInput;
        }
      }
    },
    async getActivityInfo() {
      let auth = this.$createAuth(this.$md5);
      let result = await this.$http.get(this.$url.getActivityPlan, {
        id: this.studentActivityId,
        auth: auth.code,
        time: auth.time
      });
      this.info.classId = result.data.data[0].clazzId;
      this.info.schoolId = this.studentActivityId;

    },
    showTable(n) {
      let val = 1 - this.showArray[n];
      this.$set(this.showArray, n, val)
    },
    async getHospitalInfo() {
      let auth = this.$createAuth(this.$md5);
      let result = await this.$http.get(this.$url.getHospitalInfo, {
        hospitalId: this.hospitalId,
        auth: auth.code,
        time: auth.time
      });
      let hospitalInfo = result.data.hospitalInfo;
      if (hospitalInfo != null && hospitalInfo != '') this.hospitalName = hospitalInfo.name;
    },
    async getClazzIdsByHospitalId() {
      let auth = this.$createAuth(this.$md5);
      let params = {
        hospitalId: this.hospitalId,
        schoolId: this.mjSchoolId ? this.mjSchoolId : '',
        screenType: 2,
        auth: auth.code,
        time: auth.time
      }
      if (this.longitude) {
        params.lng = this.longitude
      }
      if (this.latitude) {
        params.lat = this.latitude
      }
      let result = await this.$http.get(this.$url.getClazzIdsByHospitalId, params);
      this.listClass = result.data.clazzList;
      if(this.listClass.length <= 1) {
        this.classTxt = this.listClass[0].clazzName;
        this.info.classId = this.listClass[0].clazzId;
      }
      if (this.$route.query.sid) {
        for (let loop = 0; loop < this.listClass.length; loop++) {
          let obj = this.listClass[loop];
          if (obj.clazzName == this.$route.query.cname) {
            this.onConfirmClass(obj);
            return;
          }
        }
      }
    },
    async getListByOpenId() {
      let auth = this.$createAuth(this.$md5);
      let result = await this.$http.get(this.$url.getListByOpenId, {
        openId: this.$route.query.openId,
        hospitalId: this.hospitalId,
        auth: auth.code,
        time: auth.time
      });
      this.listName = result.data.data;
      if (this.$route.query.sid) {
        for (let loop = 0; loop < this.listName.length; loop++) {
          let obj = this.listName[loop];
          if (obj.code == this.$route.query.sid) {
            this.onConfirmName(obj);
            return;
          }
        }
      }
    },
    async getAddress(superiorId, type) {
      let auth = this.$createAuth(this.$md5);
      let result = await this.$http.get(this.$url.getAddress, {
        superiorId: superiorId,
        auth: auth.code,
        time: auth.time
      });
      if (type == 0) this.listProvince = result.data.data;
      if (type == 1) this.listCity = result.data.data;
      if (type == 2) this.listCounty = result.data.data;
    },

    async submitInfo(type, isNext) {
      if(this.schoolName && !this.info.customerSourceTwoId) {
        let data = { name: this.schoolName, hospitalId: this.hospitalId};
        if(this.sourceSchoolList && this.sourceSchoolList.length >0) {
          data.customerSourceId = this.sourceSchoolList[0].customerSourceId
        }
        let config = { headers: { 'Content-Type': 'application/json' } };
        let result = await this.$http.post(this.$url.addCustomerSourceTwo, data,config).then(res=>{
          if(res.message==='Ok') {
            this.onSearch2(this.schoolName, true, type,isNext);
          } else {
            this.$toast(res.message, 3000)
          }
        });
        return;
      } else{
      let auth = this.$createAuth(this.$md5);
      let addType = 0;
      if (type && type == 1){
        addType = 1;
      }
      if (this.isConfirm) {
        this.isConfirm = false;
        if (!this.showNext) {
          if (this.checkAll()) {
            let data = {
              openId: this.$route.query.openId,
              archivesDate: this.info.archivesDate.replace(/-/g, '/'),
              clazzId: this.info.classId,
              hospitalId: this.hospitalId,
              name: this.info.name,
              customerSourceTwoId: this.info.customerSourceTwoId,
              idCard: this.info.idCard,
              sex: this.info.gender,
              birthday: this.info.birth.replace(/-/g, '/'),
              age: this.info.age,
              phone: this.info.phone,
              address: this.info.address,
              nation: this.info.nation || '',
              province: this.info.province,
              city: this.info.city,
              county: this.info.county,
              url: '',
              schoolId: this.info.schoolId || '',
              guardianName: this.info.guardianName || '',
              guardianPhone: this.info.guardianPhone || '',
              auth: auth.code,
              time: auth.time,
              addType: addType,

            }
            if(this.studentActivityId && this.studentActivityId!='null') {
              data.studentActivityId = this.studentActivityId
            }
            if (type == 1) data.type = 1;
            if (this.topicGroupId) data.topicGroupId = this.topicGroupId;
            if (this.topicId) data.topicId = this.topicId;

            let result = await this.$http.post(this.$url.hospitalStudentAdd, data);
            let _this = this;
            setTimeout(function () {
              _this.isConfirm = true;
            }, 500)
            this.studentId = result.data.data.studentId;
            this.healthArchivesId = result.data.data.healthArchivesId;
            if (type != 1) {
              this.$router.push(`/ysgQrcode?openId=${this.$route.query.openId}&name=${this.info.name}&id=${this.studentId}`);
            }

          } else {
            let _this = this;
            setTimeout(function () {
              _this.isConfirm = true;
            }, 500)
          }
          if(isNext) {
            this.showNext = true;
            this.isFirst = false;
            this.isSecond = true;
            document.title = '个人档案补录表';
            return
          }
        }
        if (type == 1 && this.showNext) {
          let adate = this.info.archivesDate;
          this.info.dlygPicture = !this.imgShow[0] ? this.info.dlygPicture : []
          this.info.xrygPicture = !this.imgShow[1] ? this.info.xrygPicture : [];
          this.info.dlygsthPicture = !this.imgShow[2] ? this.info.dlygsthPicture : [];
          this.info.xrygsthPicture = !this.imgShow[3] ? this.info.xrygsthPicture : [];
          this.info.dlygfyPicture = !this.imgShow[4] ? this.info.dlygfyPicture : [];
          this.info.xrygfyPicture = !this.imgShow[5] ? this.info.xrygfyPicture : [];
          let data = {
            studentId: this.studentId,
            id: this.healthArchivesId,
            archivesDate: adate,
            rightNakedFar: this.info.rightNakedFar,
            leftNakedFar: this.info.leftNakedFar,
            glassesType: this.info.glassesType,
            santong: this.info.santong,
            xianran: this.info.xianran,
            rightGlassesFar: this.info.rightGlassesFar,
            leftGlassesFar: this.info.leftGlassesFar,
            rightPressure: this.info.rightPressure,
            leftPressure: this.info.leftPressure,
            rightAxialLength: this.info.rightAxialLength,
            leftAxialLength: this.info.leftAxialLength,
            rightEyeCurvatureR1: this.info.rightEyeCurvatureR1,
            leftEyeCurvatureR1: this.info.leftEyeCurvatureR1,
            rightEyeCurvatureR2: this.info.rightEyeCurvatureR2,
            leftEyeCurvatureR2: this.info.leftEyeCurvatureR2,
            auth: auth.code,
            time: auth.time,
            type: 1,
            otherRightPicture: this.imgList.toString(),
            dlygPicture: this.info.dlygPicture.toString(),// 非散瞳（电脑）验光图片
            xrygPicture: this.info.xrygPicture.toString(),// 非散瞳（显然）验光图片
            dlygsthPicture: this.info.dlygsthPicture.toString(),//  散瞳（电脑）验光图片
            xrygsthPicture: this.info.xrygsthPicture.toString(),//   散瞳（显然）验光图片
            dlygfyPicture: this.info.dlygfyPicture.toString(),//   复验（电脑）验光图片
            xrygfyPicture: this.info.xrygfyPicture.toString(),//    复验（显然）验光图片
            righttopographypicture: this.info.righttopographypicture.toString(),// 右眼生物测量仪图片
            lefttopographypicture: this.info.lefttopographypicture.toString(),//左眼生物测量仪图片
            rightbiometricspicture: this.info.rightbiometricspicture.toString(),//右眼角膜地形图图片
            leftbiometricspicture: this.info.leftbiometricspicture.toString(),//左眼角膜地形图图片
            glassesRecipe: this.info.glassesRecipe.toString(),//配镜处方图片
            visualFunctionPicture: this.info.visualFunctionPicture.toString(),//视功能图片
          }
          if (this.info.santong != 0 && this.info.xianran != 0) {
            if (this.info.santong == 1) {
              if (this.info.xianran == 1) {
                data.leftBallAvg = this.info.leftqj;
                data.rightBallAvg = this.info.rightqj;
                data.leftSylAvg = this.info.leftzj;
                data.rightSylAvg = this.info.rightzj;
                data.leftAxialAvg = this.info.leftzw;
                data.rightAxialAvg = this.info.rightzw;
                data.pupilDistance = this.info.tongju;
              } else {
                //非散瞳（显然）验光
                data.leftBallZhujue = this.info.leftqj;
                data.rightBallZhujue = this.info.rightqj;
                data.leftSylZhujue = this.info.leftzj;
                data.rightSylZhujue = this.info.rightzj;
                data.leftAxialZhujue = this.info.leftzw;
                data.rightAxialZhujue = this.info.rightzw;
                /*data.leftCorrectZhujue = this.info.leftjz;
                data.rightCorrectZhujue = this.info.rightjz;
                data.leftcorrectzhujue = this.info.leftjz;
                data.rightcorrectzhujue = this.info.rightjz;*/
                data.xrygPupilDistance = this.info.tongju;
              }
            }
          }

          //瞳孔已散大
          if (this.info.santong == 2) {
            if (this.info.xianran == 1) {
              //散瞳（电脑）验光
              data.leftBallAvgAfter = this.info.leftqj;
              data.rightBallAvgAfter = this.info.rightqj;
              data.leftSylAvgAfter = this.info.leftzj;
              data.rightSylAvgAfter = this.info.rightzj;
              data.leftAxialAvgAfter = this.info.leftzw;
              data.rightAxialAvgAfter = this.info.rightzw;
              data.pupilDistanceAfter = this.info.tongju;
            } else {
              //散瞳（显然）验光
              data.leftBallChaPian = this.info.leftqj;
              data.rightBallChaPian = this.info.rightqj;
              data.leftSylChaPian = this.info.leftzj;
              data.rightSylChaPian = this.info.rightzj;
              data.leftAxialChaPian = this.info.leftzw;
              data.rightAxialChaPian = this.info.rightzw;
              /*data.leftCorrectChaPian = this.info.leftjz;
              data.rightCorrectChaPian = this.info.rightjz;
              data.leftcorrectchapian = this.info.leftjz;
              data.rightcorrectchapian = this.info.rightjz;*/
              data.xrygsthPupilDistance = this.info.tongju;
            }
          }
          //散瞳后瞳孔已恢复
          if (this.info.santong == 3) {
            if (this.info.xianran == 1) {
              //复验（电脑）验光
              data.leftBallAvgAfter_1 = this.info.leftqj;
              data.rightBallAvgAfter_1 = this.info.rightqj;
              data.leftSylAvgAfter_1 = this.info.leftzj;
              data.rightSylAvgAfter_1 = this.info.rightzj;
              data.leftAxialAvgAfter_1 = this.info.leftzw;
              data.rightAxialAvgAfter_1 = this.info.rightzw;
              data.pupilDistanceAfter1 = this.info.tongju;
            } else {
              //复验（显然）验光
              data.leftBallZhujue_1 = this.info.leftqj;
              data.rightBallZhujue_1 = this.info.rightqj;
              data.leftSylZhujue_1 = this.info.leftzj;
              data.rightSylZhujue_1 = this.info.rightzj;
              data.leftAxialZhujue_1 = this.info.leftzw;
              data.rightAxialZhujue_1 = this.info.rightzw;
              /*data.leftCorrectZhujue_1 = this.info.leftjz;
              data.rightCorrectZhujue_1 = this.info.rightjz;
              data.leftcorrectzhujue1 = this.info.leftjz;
              data.rightcorrectzhujue1 = this.info.rightjz;*/
              data.xrygfyPupilDistance = this.info.tongju;
            }
          }
          this.info.id = this.healthArchivesId;
          if ((data.rightNakedFar != null && data.rightNakedFar != '')
            || (data.leftNakedFar != null && data.leftNakedFar != '')
            || (data.glassesType != null && data.glassesType != '')
            || (data.rightGlassesFar != null && data.rightGlassesFar != '')
            || (data.leftGlassesFar != null && data.leftGlassesFar != '')
          ) {
            data.slCheckDate = this.info.archivesDate;
          }
          if ((data.rightBallAvg != null && data.rightBallAvg != '')
            || (data.leftBallAvg != null && data.leftBallAvg != '')
            || (data.rightSylAvg != null && data.rightSylAvg != '')
            || (data.leftSylAvg != null && data.leftSylAvg != '')
            || (data.rightAxialAvg != null && data.rightAxialAvg != '')
            || (data.leftAxialAvg != null && data.leftAxialAvg != '')

          ) {
            data.dlygCheckDate = this.info.archivesDate;
          }
          if (
            (data.rightBallZhujue != null && data.rightBallZhujue != '')
            || (data.rightSylZhujue != null && data.rightSylZhujue != '')
            || (data.rightAxialZhujue != null && data.rightAxialZhujue != '')
            || (data.rightcorrectzhujue != null && data.rightcorrectzhujue != '')
            || (data.leftBallZhujue != null && data.leftBallZhujue != '')
            || (data.leftSylZhujue != null && data.leftSylZhujue != '')
            || (data.leftAxialZhujue != null && data.leftAxialZhujue != '')
            || (data.leftcorrectzhujue != null && data.leftcorrectzhujue != '')
          ) {
            data.xrygCheckDate = this.info.archivesDate
          }
          if (this.isVNull(data.rightBallAvgAfter) || this.isVNull(data.rightSylAvgAfter) || this.isVNull(data.rightAxialAvgAfter) || this.isVNull(data.leftBallAvgAfter) || this.isVNull(data.leftSylAvgAfter) || this.isVNull(data.leftAxialAvgAfter)
          ) {
            data.dlygsthCheckDate = this.info.archivesDate
          }
          if (this.isVNull(data.rightBallChaPian)
            || this.isVNull(data.rightSylChaPian)
            || this.isVNull(data.rightAxialChaPian)
            || this.isVNull(data.rightCorrectChaPian)
            || this.isVNull(data.leftBallChaPian)
            || this.isVNull(data.leftSylChaPian)
            || this.isVNull(data.leftAxialChaPian)
            || this.isVNull(data.leftCorrectChaPian)
          ) {
            data.xrygsthCheckDate = this.info.archivesDate
          }
          if (
            this.isVNull(data.rightBallAvgAfter_1)
            || this.isVNull(data.rightSylAvgAfter_1)
            || this.isVNull(data.rightAxialAvgAfter_1)
            || this.isVNull(data.leftBallAvgAfter_1)
            || this.isVNull(data.leftSylAvgAfter_1)
            || this.isVNull(data.leftAxialAvgAfter_1)
          ) {
            data.dlygfyCheckDate = this.info.archivesDate
          }
          if (
            this.isVNull(data.rightBallZhujue_1)
            || this.isVNull(data.rightSylZhujue_1)
            || this.isVNull(data.rightAxialZhujue_1)
            || this.isVNull(data.rightCorrectZhujue_1)
            || this.isVNull(data.leftBallZhujue_1)
            || this.isVNull(data.leftSylZhujue_1)
            || this.isVNull(data.leftAxialZhujue_1)
            || this.isVNull(data.leftCorrectZhujue_1)
          ) {
            data.xrygfyCheckDate = this.info.archivesDate
          }
          if (this.isVNull(data.rightPressure)
            || this.isVNull(data.leftPressure)
            || this.isVNull(data.rightAxialLength)
            || this.isVNull(data.leftAxialLength)
            || this.isVNull(data.rightEyeCurvatureR1)
            || this.isVNull(data.rightAxialView1)
            || this.isVNull(data.rightEyeCurvatureR2)
            || this.isVNull(data.rightAxialView2)
            || this.isVNull(data.leftEyeCurvatureR1)
            || this.isVNull(data.leftAxialView1)
            || this.isVNull(data.leftEyeCurvatureR2)
            || this.isVNull(data.leftAxialView2)
          ) {
            data.qtCheckDate = this.info.archivesDate
          }
          let result = await this.$http.post(this.$url.saveEyeHealthArchives, data);
          if (result.data.insertType == 1) {
            this.$toast('档案录入成功', 3000);
            this.$router.push(`/?openId=${this.$route.query.openId}`);
          } else {
            this.$toast('档案录入失败', 3000)
          }
          let _this = this;
          setTimeout(function () {
            _this.isConfirm = true;
          }, 500)
        }
      }
      }
    },
    isVNull(val) {
      return val != null && val != '';
    },
    getListTxt(list, val) {
      for (let loop = 0; loop < list.length; loop++) {
        let obj = list[loop];
        if (obj.val == val) {
          return obj.txt;
        }
      }
    },
    async goNext() {
      if (this.checkAll()) {
        await this.submitInfo(1,true);
      }
    },
    onConfirmClass(value) {
      this.classTxt = value.clazzName;
      this.info.classId = value.clazzId;
      this.showClass = false;
    },
    onConfirmName(value) {
      this.info.name = value.name;
      this.info.phone = value.phone;
      this.info.birth = value.birthday;
      if (value.id_card && value.id_card != '') this.info.idCard = value.id_card;
      this.getAge(this.info.birth);
      this.showName = false;
    },
    async onConfirmSchool(value) {
      if(!value) {
        let result = await this.$http.get(this.$url.getCustomerSourceTwos, {
          hospitalId: this.hospitalId,
          name: this.positionSearch
        });
        console.log(result)
      }else {
        this.info.customerSourceTwoId = value.id;
        this.schoolName = value.name;
      }
      this.showSchool = false;
    },
    onConfirmBirth(value) {
      this.info.birth = this.$dateFormat('YYYY-mm-dd', value);
      this.getAge(this.info.birth);
      this.showBirth = false;
    },
    onConfirmArchives(value) {
      this.info.archivesDate = this.$dateFormat('YYYY-mm-dd', value);
      this.showArchives = false;
    },
    onConfirmProvince(value) {
      this.info.province = value.itemName;
      this.info.city = '';
      this.getAddress(value.id, 1);
      this.showProvince = false;
    },
    onConfirmCity(value) {
      this.info.city = value.itemName;
      this.info.county = '';
      this.getAddress(value.id, 2);
      this.showCity = false;
    },
    onConfirmCounty(value) {
      this.info.county = value.itemName;
      this.showCounty = false;
    },
    onConfirmRightShili(value) {
      this.info.rightNakedFar = value.val;
      this.rightShiliTxt = value.txt;
      this.showRightShili = false;
    },
    onConfirmLeftShili(value) {
      this.info.leftNakedFar = value.val;
      this.leftShiliTxt = value.txt;
      this.showLeftShili = false;
    },
    onConfirmGRightShili(value) {
      this.info.rightGlassesFar = value.val;
      this.gRightShiliTxt = value.txt;
      this.showGRightShili = false;
    },
    onConfirmGLeftShili(value) {
      this.info.leftGlassesFar = value.val;
      this.gLeftShiliTxt = value.txt;
      this.showGLeftShili = false;
    },
    onConfirmGlassType(value) {
      this.info.glassesType = value.val;
      this.glassesTypeTxt = value.txt;
      this.showGlassType = false;
      this.isGlassSl = value.txt != ''
    },
    onConfirmSantong(value) {
      this.info.santong = value.val;
      this.imgShow = [true, true, true, true, true, true];
      if (value.val === 1) {
        if (this.info.xianran == 1) this.imgShow[0] = false;
        if (this.info.xianran == 2) this.imgShow[1] = false;
      }
      if (value.val === 2) {
        if (this.info.xianran == 1) this.imgShow[2] = false;
        if (this.info.xianran == 2) this.imgShow[3] = false;
      }
      if (value.val === 3) {
        if (this.info.xianran == 1) this.imgShow[4] = false;
        if (this.info.xianran == 2) this.imgShow[5] = false;
      }
      this.santongTxt = value.txt;
      this.showSantong = false;
      this.isXr = (this.info.xianran == 2) ? true : false;
      this.isCanInput = value.val != '' && this.info.xianran != ''
    },
    onConfirmYanguang(value) {
      this.info.xianran = value.val;
      this.imgShow = [true, true, true, true, true, true];
      if (value.val === 1) {
        if (this.info.santong == 1) this.imgShow[0] = false;
        if (this.info.santong == 2) this.imgShow[2] = false;
        if (this.info.santong == 3) this.imgShow[4] = false;
      }
      if (value.val === 2) {
        if (this.info.santong == 1) this.imgShow[1] = false;
        if (this.info.santong == 2) this.imgShow[3] = false;
        if (this.info.santong == 3) this.imgShow[5] = false;
      }
      this.xianranTxt = value.txt;
      this.isXr = (value.val == 2) ? true : false;
      this.showYanguang = false;
      this.isCanInput = value.val != '' && this.info.santong != ''
    },
    onConfirmRightQj(value) {
      this.info.rightqj = value;
      this.showRightQj = false;
    },
    onConfirmRightZj(value) {
      this.info.rightzj = value;
      this.showRightZj = false;
    },
    onConfirmRightZw(value) {
      this.info.rightzw = value;
      this.showRightZw = false;
    },
    onConfirmRightJz(value) {
      this.info.rightjz = value.val;
      this.rightJzTxt = value.txt;
      this.showRightJz = false;
    },
    onConfirmLeftQj(value) {
      this.info.leftqj = value;
      this.showLeftQj = false;
    },
    onConfirmLeftZj(value) {
      this.info.leftzj = value;
      this.showLeftZj = false;
    },
    onConfirmLeftZw(value) {
      this.info.leftzw = value;
      this.showLeftZw = false;
    },
    onConfirmLeftJz(value) {
      this.info.leftjz = value.val;
      this.leftJzTxt = value.txt;
      this.showLeftJz = false;
    },
    afterRead(file) {
      compressImage(file.content).then(result => {
        if (result.size > file.file.size) {
          //压缩后比原来更大，则将原图上传
          this.uploadSuccess(file.file, file.file.name);
        } else {
          //压缩后比原来小，上传压缩后的
          this.uploadSuccess(result, file.file.name)
        }
      })
    },
    /**
     * 上传图片
    */
    async uploadSuccess(file, filename) {
      let formData = new FormData();

      let auth = this.$createAuth(this.$md5);
      // 把文件信息添加进如对象
      formData.append('images', file, filename)
      formData.append('hospitalId', this.$route.query.hospitalId)

      formData.append('auth', auth.code)
      formData.append('time', auth.time)
      this.$toast.loading('上传中');
      let config = { headers: { 'Content-Type': 'multipart/form-data' } };
      const result = await this.$http.post(this.$url.uploadPictures, formData, config);
      let pic = result.data.pictures[0];
      if (this.imgIndex == 0) this.info.dlygPicture.push(pic);
      if (this.imgIndex == 1) this.info.xrygPicture.push(pic);
      if (this.imgIndex == 2) this.info.dlygsthPicture.push(pic);
      if (this.imgIndex == 3) this.info.xrygsthPicture.push(pic);
      if (this.imgIndex == 4) this.info.dlygfyPicture.push(pic);
      if (this.imgIndex == 5) this.info.xrygfyPicture.push(pic);
      if (this.imgIndex == 6) this.info.righttopographypicture.push(pic);
      if (this.imgIndex == 7) this.info.lefttopographypicture.push(pic);
      if (this.imgIndex == 8) this.info.rightbiometricspicture.push(pic);
      if (this.imgIndex == 9) this.info.leftbiometricspicture.push(pic);
      if (this.imgIndex == 10) this.info.glassesRecipe.push(pic);
      if (this.imgIndex == 11) this.info.visualFunctionPicture.push(pic);
      if (this.imgIndex == 20) this.imgList.push(pic);
      if(this.imgIndex < 6)this.ocrImg(pic, this.imgIndex);
    },
    goPriview(src) {
      let listImg = [];
      if (src.indexOf(".pdf") >= 0) {
        window.open(src)
      } else {
        listImg.push(src);
        this.isShowTip = 1;
        let _this = this;
        ImagePreview({
          images: listImg, startPosition: 0,
          showIndex: false,
          onClose() {
            _this.isShowTip = 0;
          }
        });
      }
    },
    goDel(index, name, otherIndex) {
      this.isShowConfirm = true;
      this.delImgIndx = -1;
      if (name) {
        this.delImgName = name;
        if (otherIndex) {
          this.delImgIndx = otherIndex;
        }
      } else {
        this.delImgIndx = index;
      }
    },
    /**delImgIndx
     * 删除照片
    */
    delImg() {
      if (this.delImgName) {
        if (this.delImgIndx == -1) {
          this.info[this.delImgName] = [];
        } else {
          this.info[this.delImgName].splice(this.delImgIndx, 1);
        }
        this.delImgName = '';
      } else {
        this.imgList.splice(this.delImgIndx, 1);
      }

      this.delImgIndx = -1;
      this.isShowConfirm = false;
    },

    showOtherItem() {
      this.isOtherItem = !this.isOtherItem;
      if (this.otherItemImg == require('../assets/img/up.png')) {
        this.otherItemImg = require('../assets/img/down.png')
      } else {
        this.otherItemImg = require('../assets/img/up.png')
      }
    },
    temp(index) {
      this.imgIndex = index
    },
    async getClassType() {
      const result = await this.$http.get(this.$url.checkDetail, {});
    },
    async getNameList() {
      const result = await this.$http.get(this.$url.checkDetail, {});
    },
    async getArea() {
      const result = await this.$http.get(this.$url.checkDetail, {});
    },
    checkAll() {
      if ( this.info.name == ''){
        this.$toast('姓名不能为空', 3000)
        return false;
      } else if ( this.nameErr != ''){
        this.$toast(this.nameErr, 3000)
        return false;
      }
      if (this.info.class == '') {
        this.$toast('科室不能为空', 3000)
        return false;
      }
      if (this.info.birth == '') {
        this.$toast('出生日期不能为空', 3000)
        return false;
      }
      if (this.mustInput.indexOf(';身份证;')>=0 && this.info.idCard == '') {
        this.$toast('身份证不能为空', 3000)
        return false;
      } else if (this.mustInput.indexOf(';身份证;')>=0 && this.idCareErr != ''){
        this.$toast(this.idCareErr, 3000)
        return false;
      } 
      if (this.mustInput.indexOf(';监护人姓名;')>=0 && this.info.guardianName == '') {
        this.$toast('监护人姓名不能为空', 3000)
        return false;
      } else if (this.mustInput.indexOf(';监护人姓名;')>=0 && this.guardianNameErr != ''){
        this.$toast(this.guardianNameErr, 3000)
        return false;
      } 
      if (this.mustInput.indexOf(';监护人电话;')>=0 && this.info.guardianPhone == '') {
        this.$toast('监护人电话不能为空', 3000)
        return false;
      } else if (this.mustInput.indexOf(';监护人电话;')>=0 && this.guardianPhoneErr != ''){
        this.$toast(this.guardianPhoneErr, 3000)
        return false;
      } 
      if (this.mustInput.indexOf(';学校;')>=0 && this.schoolName == '') {
        this.$toast('学校不能为空', 3000)
        return false;
      } 
      if (new Date(this.info.birth.replace(/-/g, '/')) >= new Date(this.info.archivesDate.replace(/-/g, '/'))) {
        this.$toast('建档日期要大于出生日期！', 3000);
        return false;
      }
      if (this.nameErr != '') {
        this.$toast('姓名格式不正确', 3000)
        return false;
      }
      /*if (this.info.class == '') {
        this.$toast('科室不能为空', 3000)
        return false;
      }
      if (this.info.name == '') {
        this.$toast('姓名不能为空', 3000)
        return false;
      }
      if (this.info.birth == '') {
        this.$toast('出生日期不能为空', 3000)
        return false;
      }
  
      if (this.info.phone == '') {
        this.$toast('手机不能为空', 3000)
        return false;
      }
      if (!(/^1[3456789]\d{9}$/.test(this.info.phone))) {
        this.$toast('手机不符合规则', 3000)
        return false;
      }
      if (this.info.idCard != undefined && this.info.idCard != '') {


        let yz1 = /(^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$)|(^[1-9]\d{5}\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{2}$)/.test(this.info.idCard);
        let yz2 = /(^[a-zA-Z][0-9]{9})|(^[A-Z][0-9]{8})|(^[A-Z][0-9]{6}[(（][0-9a-zA-z][)）])$/.test(this.info.idCard);
        if (!yz1 && !yz2) {
          this.$toast('身份证不符合规则', 3000);
          return;
        }
      }*/
      return true;
    },
    getAge(birthday) {
      if (birthday && birthday.indexOf('-') > 0) {
        var strs = birthday.split('-');
        var yearBirth = strs[0];
        var monthBirth = strs[1];
        var dayBirth = strs[2];
        //获取当前年月日并计算年龄
        var myDate = new Date();
        var monthNow = myDate.getMonth() + 1;
        var dayNow = myDate.getDay();
        birthday = birthday.replace(/-/g, '/')
        var age = Math.round((myDate.getTime() - new Date(birthday).getTime()) / (365 * 24 * 60 * 60 * 1000));
        //得到年龄
        this.info.age = age;
      }
    }


  }
}
</script>
<style scoped lang='less'>
.container {
  padding: 0.3rem;
}

.info-title {
  font-size: 0.4rem;
}

.info-tip {
  margin: 0.2rem 0 0.3rem;
  font-size: 0.3rem;
}

.info-content {
  font-size: 0.3rem;

  div {
    text-align: left;
  }
}

.info-name-field {
  position: relative;
}

.field-sel {
  position: absolute;
  top: 0.1rem;
  left: 5.5rem;
  width: 1rem;
  padding: 0 0.1rem 0.05rem;
  border: 1px solid #ccc;
  color: #666;
  border-radius: 0.1rem;
}

.submit-btn {
  width: 4.5rem;
  margin: 0.3rem 0 0;
  background-color: #5CC4AB;
  color: #fff;
  border-radius: 5px;
}

.flex-div-yanguang {
  display: flex;
  flex-wrap: wrap;

  div {
    width: 1.3rem;
    border: 1px solid #000;
  }
}

.flex-div-yanya {
  display: flex;
  flex-wrap: wrap;

  div {
    width: 2.1rem;
    border: 1px solid #000;
  }
}

.other-item-tip {
  display: flex;
  margin: 0.15rem;
  text-align: left;
  font-weight: 500;

  img {
    width: 0.4rem;
    margin: 0.05rem 0.2rem;
  }
}

.other-item {
  margin-left: 0.3rem;
}

.module-txt {
  width: 7.5rem;
  margin-left: -0.3rem;
  padding: 0.25rem 0;
  font-size: 0.32rem;
  text-align: center;
  color: #666;
  border-top: 0.01rem solid #CCC;
  background: rgba(0, 172, 96, 0.3);
}

.report-table {
  width: 7.5rem;
  margin-left: -0.3rem;
  border-top: 1px solid #ccc;
  font-size: 0.28rem;
  border-bottom: 0;

  td {
    width: 1.3rem;
    padding: 0.1rem;
    text-align: center;
    background: #fff;

    &.txt-left {
      text-align: left;
    }

    &.txt-tip {
      color: #999;
      font-size: 0.28rem;
      text-align: left;
    }

    &.img-td {
      padding: 0.3rem 0;
    }

    &.td-big {
      width: 3rem;
      box-sizing: border-box;
    }

    &.td-big-more {
      width: 3.5rem;
      color: #999;
      box-sizing: border-box;
    }

    input {
      width: 1rem;
      padding: 0 0.1rem;

      &.input-big {
        width: 2rem;
      }
    }
  }
}

.other-photo {
  width: 1rem;
  height: 1rem;
  line-height: 1rem;
  text-align: center;
  font-size: 0.4rem;
  border: 1px solid #ddd;
}

.dz-img-box {
  margin: 0.3rem auto;

  .dz-img {
    position: relative;
    margin-right: 0.2rem;

    img {
      width: 2rem;
      height: 2rem;
    }

    .counsel_del {
      position: absolute;
      right: -5px;
      top: -5px;
      color: #f33;
    }
  }
}

.dz-img {
  img {
    margin: 15px auto 5px;
  }

  span {
    margin: 15px auto;
    padding: 5px 10px;
    border-radius: 5px;
    font-size: 0.28rem;
    color: #666;
  }
}

.van-popup {
  border-radius: 10px;

  .con_box {
    width: 5.5rem;
    line-height: 1;
    text-align: center;
    color: #4d5c82;
    padding: 15px;
    box-sizing: border-box;

    h3 {
      width: 5.5rem;
      font-size: 20px;
      margin-top: 10px;
      margin-bottom: 20px;
    }

    p {
      width: 5.5rem;
      font-size: 17px;
      margin-bottom: 30px;
    }

    .pop-btn {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;

      >span {
        display: block;
        width: 114px;
        background-color: #e0e5f5;
        text-align: center;
        line-height: 44px;
        font-size: 17px;
      }

      >span:last-of-type {
        background-color: #12B5C4;
        color: #ffffff;
      }
    }
  }
}

.menudown {
  position: relative;
  top: 0.05rem;
  width: 0.3rem;
  margin-left: 0.2rem;
}

.menuup {
  position: relative;
  top: 0.05rem;
  width: 0.3rem;
  margin-left: 0.2rem;
  transform: rotate(180deg);
}

.ml10 {
  margin-left: 0.1rem;
}

.flex {
  display: flex;
  flex-wrap: wrap;
}

.input-big {
  width: 4rem;
}

.border-no-top {
  border-top: 0;
}

.require {
  margin-right: 0.1rem;
  color: #f33;
}

.input-div {
  display: flex;
  border: 1px solid #ccc;
  border-radius: 0.05rem;
  padding: 0.1rem;

  input {
    border: none;
  }

  img {
    width: 0.3rem;
    max-width: 0.3rem;
  }
}
</style>
